import { useState } from "react";

/**
 * FIX-012 (public signup + real transactional email), "Tell your friends
 * about us": a convenient way for ANY logged-in user (not OWNER-only) to
 * share the SAME canonical public signup URL. Deliberately makes ZERO
 * backend calls: the URL is built purely client-side from
 * `window.location.origin` (the browser is already on the real
 * configured application origin, whatever it is — never a second source
 * of truth to keep in sync with `APP_BASE_URL`), so this can never
 * create a user, workspace, membership, license, invitation record, or
 * any personal/unique token — there is no referral/affiliate/attribution
 * system here, by design.
 *
 * Rendered on BOTH `AccountPage` and the GENERATE `DashboardTab`
 * (2026-09-07 follow-up) — the product requirement is that every user
 * sees it without hunting for it, and Dashboard is the first screen a
 * user reaches after login, so it belongs there too, not only behind
 * the account-name link in the top nav.
 */
export function TellYourFriendsCard() {
  const [copied, setCopied] = useState(false);
  const signupUrl = `${window.location.origin}/signup`;
  const canShare = typeof navigator !== "undefined" && typeof navigator.share === "function";

  async function handleShare(): Promise<void> {
    try {
      await navigator.share({ url: signupUrl });
    } catch {
      // The user dismissed the native share sheet, or the platform
      // rejected it — never an error state for a user backing out.
    }
  }

  async function handleCopyLink(): Promise<void> {
    await navigator.clipboard.writeText(signupUrl);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  }

  function handleOpenLink(): void {
    window.open(signupUrl, "_blank", "noopener,noreferrer");
  }

  return (
    <div className="card">
      <h3>Tell your friends about us</h3>
      <p>Share this link with anyone you think would enjoy creating videos with VIDEO STUDIO.</p>
      <div style={{ display: "flex", gap: 8, flexWrap: "wrap" }}>
        {canShare && (
          <button type="button" onClick={() => void handleShare()}>
            Share
          </button>
        )}
        <button type="button" onClick={() => void handleCopyLink()}>
          {copied ? "Copied!" : "Copy link"}
        </button>
        <button type="button" onClick={handleOpenLink}>
          Open link
        </button>
      </div>
    </div>
  );
}
